import { PLATFORMS } from 'core/constants/platform.constants';
import { IPlatformState } from './types';

export const SLICE_NAMESPACE = 'platform';

export const initialState: IPlatformState = {
  selectedPlatform: PLATFORMS[0].id,
};
